import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import RequestRow from './RequestRow'

function SortableRequestRow({ request, userRole, canEdit, onPriorityChange }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: request.link_id,
    disabled: !canEdit,
    data: {
      status: request.customer_status,
    },
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <RequestRow
        request={request}
        userRole={userRole}
        isDragging={isDragging}
        canEdit={canEdit}
        onPriorityChange={onPriorityChange}
      />
    </div>
  )
}

export default SortableRequestRow
